<script>
  import AddList from "../form/AddList.svelte";
  import InputWrapper from "../form/InputWrapper.svelte";
  import PlainInput from "../form/PlainInput.svelte";
  import SingleCheckbox from "../form/SingleCheckbox.svelte";
  import Validators from "../../utils/validators";

  // fields
  let vastField = [
    {
      type: "text",
      name: "vast",
      label: "Vast",
      readonlyValue: true,
      validations: [Validators.required("Vast is required")],
    },
  ];

  let vast2Field = [
    {
      type: "text",
      name: "vast2",
      label: "Vast 2",
      readonlyValue: true,
      validations: [Validators.required("Vast2 is required")],
    },
  ];

  let weightField = [
    {
      type: "text",
      name: "weight",
      label: "Weight",
      readonlyValue: true,
      validations: [Validators.required("Weight is required")],
    },
  ];

  let vastData = [];
  let vast2Data = [];
  let weightData = [];

  let iab_category = "";
  let ad = "";
  let ad_topper = "";
  let length = "";
  let ad_server = "";
  let isEven = true;

  function onAddVast(data) {
    const newVast = { ...data };
    vastData.push(newVast);
    return vastData;
  }

  function onDeleteVast(index) {
    vast2Data.splice(index, 1);
    return vastData;
  }

  function onAddVast2(data) {
    const newVast = { ...data };
    vast2Data.push(newVast);
    return vast2Data;
  }

  function onDeleteVast2(index) {
    vast2Data.splice(index, 1);
    return vast2Data;
  }

  function onAddWeight(data) {
    const newWeight = { ...data };
    weightData.push(newWeight);
    return weightData;
  }

  function onDeleteWeight(index) {
    weightData.splice(index, 1);
    return weightData;
  }
</script>

<div class="flex flex-row w-full gap-2 pb-2">
  <InputWrapper label="IAB Category">
    <PlainInput name="iab_category" bind:value={iab_category} />
  </InputWrapper>
  <InputWrapper label="Ad Domain">
    <PlainInput name="ad" bind:value={ad} />
  </InputWrapper>
  <InputWrapper label="Ad Topper Type">
    <PlainInput name="ad_topper" value={ad_topper} />
  </InputWrapper>
</div>

<div class="flex flex-row w-full gap-2 pb-2">
  <div class="w-1/3">
    <AddList
      name="vast"
      fields={vastField}
      data={vastData}
      onAddRow={onAddVast}
      onDeleteRow={onDeleteVast} />
  </div>
  <div class="w-1/3">
    <InputWrapper label="Length">
      <PlainInput name="length" value={length} />
    </InputWrapper>
  </div>
  <div class="w-1/3">
    <InputWrapper label="Ad Server">
      <PlainInput name="ad_server" value={ad_server} />
    </InputWrapper>
  </div>
</div>

<div class="flex flex-row w-full gap-2">
  <div class="w-1/3">
    <AddList
      name="vast2"
      fields={vast2Field}
      data={vast2Data}
      onAddRow={onAddVast2}
      onDeleteRow={onDeleteVast2} />
  </div>
  <div class="w-1/3">
    <AddList
      name="weight"
      fields={weightField}
      data={weightData}
      onAddRow={onAddWeight}
      onDeleteRow={onDeleteWeight} />
  </div>
  <div class="w-1/3">
    <SingleCheckbox name="even" label="Even" bind:value={isEven} />
  </div>
</div>
